import React, {Component} from 'react';
import {SERVER_URL}  from '../Constants';
import axios from 'axios';
import auth0Client from '../Auth';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
//const airports = require('../Portal/Airports.json');  //use this for auto-complete


class LostItemAuditChanges extends Component {
    constructor(props) {
      super(props);

        this.state = {
            
            status:'',
            lostItemId: (this.props.lostItemId),
            auditItems:[],

        }
    }
    

    async componentDidMount(){
        this.loadLostItemHistory(this.state.lostItemId)
    }

    loadLostItemHistory=(lostItemId)=>{
// Load the item history for the selected row int he list 

    console.log(lostItemId);
   this.setState({status:'Loading...Please Wait'});
   try {
       axios.get(`${SERVER_URL}/Reports/lostItemAuditTrail`,{
          headers: { 
            'Authorization': `Bearer ${auth0Client.getIdToken()}`,
            'venueId' : auth0Client.getActiveVenuedId(),
            'id' : lostItemId,
          },
     
          
        
        }).then((res)=>{
          
          if (res.status === 401) {
            //place your reentry code
            console.log("Error" + res.status);
           
           }
  
          const auditItems = res.data.auditResults;
          console.log(auditItems);
          if (auditItems){
            for (var i=0; i <auditItems.length; i++){
                auditItems[i].key =i;
            } 
          }
          
          this.setState(
              {
               auditItems: auditItems,
               status:auditItems.length + ' returned'}
               ); 
         


         });
     }catch(e){
        
         this.setState(
            {
             auditItems: [],
             status:'An error occured in the report.'}
             ); 
     }

    }
    formateDate=(dateStr)=>{
        try {
            if (dateStr){
                console.log(dateStr);
                var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
                let cellDate = new Date(dateStr);
                return cellDate.toLocaleDateString([],options) +  ' ' + cellDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second:'2-digit'});
            }else{
                return  '';
            }
        }catch(e){
            return  '';

        }
    }
    fromToFormatter=(cell, row)=>{
            return(
                <small><b>From:</b> {row.from} <br/><b>To: </b>{row.to}</small>
            )
    }
    modifiedByCol=(cell,row)=>{
        return(
            <small><b>By :</b> {row.by} <br/><b>At: </b>{this.formateDate(row.on)}</small>
        )
    }

    renderTable=()=>{

        const columns = [{
            dataField: 'key',
            text: '#',
            formatter:(cell,row)=>{return(<small>{row.key}</small>)},
            headerStyle: {width:'40px',}
          }, {
            dataField: 'field',
            text: 'Field',
            formatter:(cell,row)=>{return(<small>{row.field}</small>)},
            headerStyle: {width:'150px'}
          }, {
            dataField: 'from',
            text: 'from',
            formatter: this.fromToFormatter
          },  {
            dataField: 'by',
            text: 'Modified By',
            formatter:this.modifiedByCol,
          }];
          
         return(<BootstrapTable  className="table-sm"
                    striped
                    condensed
                    keyField='key' data={ this.state.auditItems } 
                    columns={ columns } />);
    }


    renderuglt=()=>{
        return(
            <table border="1" style={{width:'100%'}}>
                    <thead>
                        <tr>
                        <th>#</th>
                        <th>field</th>
                        <th>from/to</th>
                       
                        <th>Modified By</th>
                        </tr>
                    </thead>
                <tbody>
                    <tr>
                    <td colSpan="4">
                        <div style={{overflow:'scroll', height:'400px'}}>
                        <table border="1" style={{width:'100%'}}>
                        <thead>
                        <tr>
                        <th>#</th>
                        <th>field</th>
                        <th>from/to</th>
                       
                        <th>Modified By</th>
                        </tr>
                    </thead>
                            <tbody>
                        {this.state.auditItems.map(auditItem=>{
                                return(
                                    <tr key={auditItem.key} style={{borderBottom:'1pt solid black'}}>
                                        <td><small>{auditItem.key}</small></td>
                                        <td><small>{auditItem.field}</small></td>
                                        <td><small><b>From:</b>{auditItem.from} <br/><b>To:&nbsp;&nbsp;&nbsp;&nbsp;</b>{auditItem.to}</small></td>
                                       
                                        <td><small>{auditItem.by} <br/> At {this.formateDate(auditItem.on)}</small></td>
                                       
                                    </tr>
                                )
                        })}
                        </tbody>
                        </table>
                        </div>
                        </td>
                       
                        </tr>
                       
                       
                        </tbody>
                </table>
        )
    }


   
    render() {
       
        return (

            <div className="p-3"  >
           
            <div className='row'>
                 <h5> Audit Trail of Changes: </h5>
            </div>
            <div className='row'>
                <div className='col'>
                <label htmlFor="gate" className='text-primary'>{this.state.status}</label>
                <br/>
                
               
               {this.renderTable()}



                
                </div>

           
            </div>
            <hr/>
          

            

        

        </div>


        )
    }

}

export default LostItemAuditChanges;